import React from 'react';
import {
  SimpleGrid,
  Text,
  HStack,
  IconButton,
  Icon,
} from '@wegroup/design-system';
import { InsurancePolicyPackage } from '../../../../../../types/AdvisoryReport';
import { UploadResponse } from '../../../../../../../../common/src/hooks/useUpload';
import { PartyDocument } from '../../../../../../../../parties/src/types';
import LabeledParamFallback from '../../../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import { useTranslation } from 'react-i18next';

interface Props {
  data: InsurancePolicyPackage;
}

const InsurancePolicyPackageItemDocuments: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const handleDocumentDownload = (document: UploadResponse | PartyDocument) => {
    if ('link' in document && document.link) {
      window.open(document.link, '_blank');
    }
  };

  const documents =
    data.documents?.filter((document) => 'link' in document && document.link) ||
    [];

  if (documents.length === 0) {
    return null;
  }

  return (
    <SimpleGrid pt="2" pb="4" columns={documents.length} gridGap="4">
      {documents.map((document, index) => (
        <LabeledParamFallback
          key={'id' in document ? document.id : index}
          label={t('Documents')}
        >
          <HStack justify="space-between" align="center" pr="4">
            <Text textStyle="smallBody">{document.filename}</Text>
            <IconButton
              variant="white"
              size="sm"
              aria-label="Download document"
              icon={<Icon name="GeneralActionsDownload" />}
              onClick={() => handleDocumentDownload(document)}
              isDisabled={!('link' in document && document.link)}
            />
          </HStack>
        </LabeledParamFallback>
      ))}
    </SimpleGrid>
  );
};

export default InsurancePolicyPackageItemDocuments;
